var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "congestion-card-item" }, [
    _c("div", { staticClass: "card-item-title" }, [
      _vm._v("最堵" + _vm._s(_vm.cardData.cardName)),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-item-info" }, [
      _c("span", { staticClass: "card-item-area" }, [
        _vm._v(_vm._s(_vm.cardData.cardArea)),
      ]),
      _vm._v(" "),
      _vm.cardData.desc
        ? _c(
            "span",
            {
              staticClass: "card-item-state",
              style: {
                color: _vm.cardData.color,
                background: _vm.cardData.bgColor,
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.cardData.desc))]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }